export const landingRegistry = {
  "/": {
    appName: "Abra Controls Directive 83",
    heroTitle: "Fracture Planning Zone Analysis With Reports",
    heroSubtitle: "Generate, save, and reuse structured FPZ reports with ease.",
    heroImageUrl: null,
    primaryCta: {
      authed: { label: "Open App", href: "/app" },
      guest: { label: "Get Started", href: "/sign-in" },
    },
    secondaryCta: {
      authed: { label: "See features", href: "#features" },
      guest: { label: "Learn more", href: "#features" },
    },
  },
  "/jobs": {
    appName: "Abra Controls Directive 83",
    heroTitle: "Turn Reports into Jobs",
    heroSubtitle: "Use your reports to create jobs with Abra Controls for wireless surface pressure monitoring.",
    heroImageUrl: null,
    primaryCta: {
      authed: { label: "Open App", href: "/app" },
      guest: { label: "Get Started", href: "/sign-in" },
    },
    secondaryCta: {
      authed: { label: "See features", href: "#features" },
      guest: { label: "Learn more", href: "#features" },
    },
  },
  // add more slugs here
};